<div class="chat-input">
  <!-- Pending attachments preview -->
  <div class="chat-input__attachments" *ngIf="pendingAttachments.length > 0">
    <div class="chat-input__att-item" *ngFor="let att of pendingAttachments; let i = index"
         [class.error]="att.mediaType === 'error'">
      <img *ngIf="isImage(att)" class="chat-input__att-thumb" [src]="imagePreviewUrl(att)" [alt]="att.fileName" />
      <span class="chat-input__att-name">{{ attachmentLabel(att) }}</span>
      <button type="button" class="chat-input__att-remove" (click)="removeAttachment(i)">&times;</button>
    </div>
  </div>

  <div class="chat-input__row">

    <!-- ── Extras toggle: groups clip / camera / mic into a single "+" button ── -->
    <div class="chat-input__extras-wrap">
      <button type="button"
              class="chat-input__icon-btn"
              [class.active]="showExtras"
              (click)="toggleExtras($event)"
              [attr.aria-label]="'chatAi.input.extras' | translate"
              [title]="'chatAi.input.extras' | translate"
              [attr.aria-expanded]="showExtras"
              aria-haspopup="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>

      <!-- Dropdown panel -->
      <div class="chat-input__extras-panel" *ngIf="showExtras" role="menu">
        <!-- File upload -->
        <button type="button"
                class="chat-input__extras-item"
                role="menuitem"
                (click)="triggerFileUpload(); closeExtras()"
                [attr.aria-label]="'chatAi.input.upload' | translate">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               aria-hidden="true">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
          </svg>
          <span>{{ 'chatAi.input.upload' | translate }}</span>
        </button>

        <!-- Camera capture -->
        <button type="button"
                class="chat-input__extras-item"
                role="menuitem"
                *ngIf="cameraSupported"
                (click)="triggerCamera(); closeExtras()"
                [attr.aria-label]="'chatAi.input.camera' | translate">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               aria-hidden="true">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
          <span>{{ 'chatAi.input.camera' | translate }}</span>
        </button>

        <!-- Microphone -->
        <button type="button"
                class="chat-input__extras-item"
                role="menuitem"
                [class.recording]="recording"
                *ngIf="micSupported"
                (click)="toggleMic(); closeExtras()"
                [attr.aria-label]="'chatAi.input.mic' | translate">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               aria-hidden="true">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
            <line x1="12" y1="19" x2="12" y2="23"/>
            <line x1="8" y1="23" x2="16" y2="23"/>
          </svg>
          <span>{{ recording ? ('chatAi.input.micStop' | translate) : ('chatAi.input.mic' | translate) }}</span>
        </button>
      </div>
    </div>

    <!-- Hidden file inputs -->
    <input #fileInput type="file" class="chat-input__file-hidden"
           [accept]="acceptedFileTypes"
           (change)="onFileSelected($event)" />
    <input #cameraInput type="file" class="chat-input__file-hidden"
           [accept]="acceptedCameraTypes"
           capture="environment"
           (change)="onCameraCapture($event)" />

    <!-- Text input wrapper — counter overlays the bottom-right corner -->
    <div class="chat-input__ta-wrap">
      <textarea #ta
                class="chat-input__ta"
                rows="1"
                [disabled]="busy"
                [maxlength]="maxChars"
                [(ngModel)]="value"
                (input)="onInput()"
                (keydown)="onKeyDown($event)"
                [attr.aria-label]="'chatAi.input.ariaLabel' | translate"
                [placeholder]="'chatAi.input.placeholder' | translate"></textarea>
      <span *ngIf="showCounter"
            class="chat-input__counter"
            [class.warn]="remaining < 200"
            aria-live="polite"
            [attr.aria-label]="remaining + ' caracteres restantes'">{{ remaining }}</span>
    </div>

    <!-- Send / Cancel button -->
    <button *ngIf="!busy" type="button"
            class="chat-input__send"
            [disabled]="!canSend"
            (click)="submit()"
            [attr.aria-label]="'chatAi.input.send' | translate"
            [title]="'chatAi.input.send' | translate">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="22" y1="2" x2="11" y2="13"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    </button>
    <button *ngIf="busy" type="button"
            class="chat-input__cancel"
            (click)="cancelRequest.emit()"
            aria-label="Cancelar"
            title="Cancelar solicitud">
      <span class="chat-input__cancel-spinner"></span>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>
</div>
